import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Card, CardContent, Alert } from '@mui/material';
import useAuthStore from '../../store/authStore.js';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login(email.trim(), password)) {
      navigate('/admin');
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <Box maxWidth={420} mx="auto">
      <Card className="glass">
        <CardContent>
          <Typography variant="h5" gutterBottom>Admin Login</Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField label="Email" type="email" fullWidth sx={{ mb: 2 }} value={email} onChange={(e)=>setEmail(e.target.value)} required />
            <TextField label="Password" type="password" fullWidth sx={{ mb: 2 }} value={password} onChange={(e)=>setPassword(e.target.value)} required />
            <Button type="submit" variant="contained" fullWidth>Login</Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}


